import { client } from 'app/http';

export const checkIsSlugAvailable = async (slug: string) => {
  const { data } = await client.get(`/organizations/is-available/${slug}`);
  return data;
};
